import type RootState from 'app-components/utils/redux-store/rootState';

export type CacheObject = { version: number; data: any };
export type Migrate = () => Promise<CacheObject | undefined>;
export type ReducerConfig<S extends keyof RootState> = {
  version: number;
  encrypt?: boolean;
  migrate?: Migrate;
  onChange?: (lastState: any, nextState: any) => void;
  stateToCache?: (state: RootState[S]) => any;
  cacheToState?: (cache: unknown) => RootState[S];
  shouldPersist?: (lastState: RootState[S] | undefined, nextState?: RootState[S] | undefined) => boolean;
};
export type PersistableStateConfig = { [key in keyof RootState]?: ReducerConfig<key> } & {
  [key: string]: ReducerConfig<any>;
};
export type StorageInterface = {
  getItem: (key: string) => Promise<string | null | undefined>;
  setItem: (key: string, value: string) => Promise<void | string>;
  removeItem: (key: string) => Promise<void>;
  clear: () => Promise<void>;
};
export type Config = {
  version: number;
  persistableStateConfig: PersistableStateConfig;
  stateKeys: Array<string>;
  cacheMetadataKey: string;
  encryptionKey: string;
  getCacheKeyForStateKey?: (stateKey: string) => string;
  storageInterface: StorageInterface;
};

export const defaultGetCacheKey = (key: string) => key;

export let config: Config | undefined;

export function initializeConfig(newConfig: Omit<Config, 'stateKeys'>) {
  config = {
    ...newConfig,
    stateKeys: Object.keys(newConfig.persistableStateConfig),
  };

  return config;
}
